// Shared Supabase project (ref: stuanfoqztvpmxymqquu)
// URL and anon key are PUBLIC (safe in client bundle).
export const SUPABASE_URL = "https://stuanfoqztvpmxymqquu.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN0dWFuZm9xenR2cG14eW1xcXV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk0NTQ2MDYsImV4cCI6MjA5NTAzMDYwNn0.x1mRibaabaP_ubggkZTBdG22A8-uHOMqh8BY9q9r3u8";